import * as React from 'react';
import { CustomerTokenContextType, CustomerTokenContext } from 'contexts/CustomerTokenContext';

export const useCustomerToken = (): CustomerTokenContextType => {
  const context = React.useContext(CustomerTokenContext);
  if (!context) {
    throw new Error('useCustomerToken must be used within a CustomerTokenProvider');
  }
  return context;
};
